// extracted by mini-css-extract-plugin
export var cardContainer = "_op-0";
export var cardHeader = "_op-2";
export var collapsedState = "_op-3";
export var dragHandle = "_op-5";
export var dragHandleIcon = "_op-6";
export var dragging = "_op-1";
export var titleArea = "_op-4";